<div
  class="select-group-container"
  [ngClass]="{
    error: control.touched && control.errors && control.validator,
    success: control.touched && !control.errors && control.validator
  }"
>
  <span *ngIf="label" (click)="clickMatSelect($event)" (keydown.enter)="clickMatSelect($event)" class="label">{{
    label
  }}</span>

  <mat-select
    [placeholder]="placeholder"
    disableOptionCentering="true"
    [formControl]="control"
    [id]="idSelect"
    ngDefaultControl
    [multiple]="multiple"
    [disabled]="disabledSelect"
  >
    <mat-option *ngFor="let val of values" [value]="val.code">
      {{ val.name }}
    </mat-option>
  </mat-select>

  <span
    class="text-caption"
    *ngIf="
      !control.validator ||
      (!(control.touched && control.errors) &&
        !(control.touched && successMessage))
    "
    >{{ textCaption }}</span
  >

  <span class="error-message" *ngIf="control.touched && control.errors">{{
    displayError(control.errors)
  }}</span>

  <span
    class="success-message"
    *ngIf="
      successMessage && control.touched && !control.errors && control.validator
    "
    >{{ successMessage }}</span
  >
</div>
